import React from 'react';
import styled from 'styled-components';
import Robot from '../assets/robot.gif'

function Welcome({currentUser}) {
  return (
    <Container>
      <div className="welcome">
    <img src={Robot} alt="Robot" />
    <h1>
      Welcome, <span>{currentUser.username} !</span>
    </h1><br />
    <h3>Please select a chat to Start messaging.</h3>
    </div>
  </Container>
  )
}
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  flex-direction: column;
  @media screen and (max-width: 420px) {
 h1,h3{
  font-size:20px;
  margin-left:38px;
 }

  }
  img {
    height: 20rem;
  }
  span {
    color: #4e0eff;
  }
  .welcome{
    margin-bottom:114px;
  }
`;
export default Welcome
